module.exports = __webpack_public_path__ + "fonts/Montserrat-SemiBold.c641dbee.ttf";